import React from "react"
import { format, isValid } from "date-fns"

export default function DateTime({
  date,
  displayFormat = `MMMM do 'at' h:mm a`,
  ...rest
}) {
  return isValid(date) ? (
    <time dateTime={date.toString()} {...rest}>
      {`${format(date, displayFormat)}`}
    </time>
  ) : null
}
